const isCallingApi = state => state.commonStore.isCallingApi;
const authUser = state => state.user_info && state.user_info.user_id;

export default {
  isCallingApi,
  authUser
}



// WEBPACK FOOTER //
// ./src/stores/getters.js